import CaptionButton from "components/Captions/CaptionButton";
import getDefaultTextTrackLanguage from "selectors/captions/getDefaultTextTrackLanguage";
import { connect } from "react-redux";
import {
  setCaptionsSelectionMenuVisibility,
  setTextTrackLanguage,
  showTextTrackCaptionSettings,
} from "actions/CaptionActions";
import { setPlayerOptions } from "actions/PlayerOptionsActions";
import getUseCaptionDialog from "selectors/breakpoint/getUseCaptionDialog";

const mapStateToProps = (state, props) => {
  const textTrack = getDefaultTextTrackLanguage(state);

  return {
    isActive:
      state.captions.textTrackLanguage !== null &&
      state.captions.textTrackLanguage !== "",
    isChapterCoverShowing: props.isChapterCoverShowing,
    playerOptions: state.playerOptions,
    showingMenu:
      state.captions.showCaptionsSelectionMenu &&
      !getUseCaptionDialog(state, props),
    textTrack,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setTextTrackLanguage: (language) => dispatch(setTextTrackLanguage(language)),
  showTextTrackSettings: () => dispatch(showTextTrackCaptionSettings()),
  setShowMenu: (showing) =>
    dispatch(setCaptionsSelectionMenuVisibility(showing)),
  setPlayerOptions,
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CaptionButton);
